function Skills() {
  return (
    <div className="ab-br">
      <p className="light pd-bt">//skills</p>
      <p>React • Redux • JavaScript </p>
      <p>Tailwind • Style Components • SCSS • Bootstrap</p>
      <p>NPM • Git • Webpack</p>
      <p>Figma</p>
      <p>Node • Express</p>
      <p>SQL • MongoDb • GraphQL</p>
    </div>
  );
}

export default Skills;
